export const omleidingennet = {
  red: "#D32F2F",
  green: "#388E3C",
  orange: "#FB8500",
};

export type LineColor = "DetourLine" | "ClosingLine" | "RestrictedLine" | "default";

export const LineColors = {
  DetourLine: omleidingennet.green,
  ClosingLine: omleidingennet.red,
  RestrictedLine: omleidingennet.orange,
  default: "#000000",
};
